import Modal from 'react-modal';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createQrConfiguration } from 'api/qr';
import swal from 'sweetalert';

Modal.setAppElement('#root');

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nombre requerido'),
    target_url: Yup.string().url('URL inválida').required('URL destino requerida'),
    description: Yup.string(),
    is_active: Yup.boolean(),
});

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onCreated: () => void;
}

const QrCreateModal = ({ isOpen, onClose, onCreated }: Props) => {
    const formik = useFormik({
        initialValues: { name: '', target_url: '', description: '', is_active: true },
        validationSchema,
        onSubmit: async (values, helpers) => {
            try {
                await createQrConfiguration(values);
                helpers.resetForm();
                onCreated();
                onClose();
            } catch (err: any) {
                const msg = err?.response?.data?.target_url?.[0]
                    || err?.response?.data?.name?.[0]
                    || 'Error al crear la configuración QR';
                swal('Afinidata', msg, 'error');
            }
        },
    });

    const field = (name: keyof typeof formik.values, label: string, type = 'text') => (
        <div className="form-group">
            <label>{label}</label>
            <input
                type={type}
                name={name}
                className={`form-control ${formik.errors[name] && formik.touched[name] ? 'is-invalid' : ''}`}
                value={formik.values[name] as string}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
            />
            {formik.errors[name] && formik.touched[name] && (
                <div className="invalid-feedback">{formik.errors[name]}</div>
            )}
        </div>
    );

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Crear QR"
            style={{
                overlay: { backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 },
                content: { position: 'relative', inset: 'auto', maxWidth: 520, width: '100%', borderRadius: 8, padding: 0 }
            }}>
            <div className="card mb-0">
                <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Crear configuración QR</h5>
                    <button className="btn btn-sm btn-light" onClick={onClose}>&times;</button>
                </div>
                <div className="card-body">
                    <form onSubmit={formik.handleSubmit}>
                        {field('name', 'Nombre')}
                        {field('target_url', 'URL destino', 'url')}
                        <div className="form-group">
                            <label>Descripción</label>
                            <textarea
                                name="description"
                                className="form-control"
                                rows={2}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </div>
                        <div className="form-group form-check">
                            <input type="checkbox" className="form-check-input" id="is_active_create"
                                name="is_active" checked={formik.values.is_active} onChange={formik.handleChange} />
                            <label className="form-check-label" htmlFor="is_active_create">Activo</label>
                        </div>
                        <div className="d-flex justify-content-end">
                            <button type="button" className="btn btn-secondary mr-2" onClick={onClose}>Cancelar</button>
                            <button type="submit" className="btn btn-primary" disabled={formik.isSubmitting}>
                                {formik.isSubmitting ? 'Guardando...' : 'Crear'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default QrCreateModal;
